import { Route, Routes } from 'react-router-dom'
import HomePage from './HomePage/HomePage'
import NavBar from './NavBar/NavBar'
import RelayersPage from './RelayerPage/RelayersPage'
import RelaysPage from 'src/components/Relays/RelaysPage'
import DetailsPage from 'src/components/Relays/Details/DetailsPage'
import PageFooter from './PageFooter/PageFooter'
import ConnectionsPage from './Connections/Connections'
import ExternalTokensPage from 'src/components/Tokens/ExternalTokensPage'

const Page: React.FC = () => {
  return (
    <>
      <NavBar />
      <Routes>
        <Route path='/' element={<HomePage />} />
        <Route path='relays' element={<RelaysPage />} />
        <Route path='relays/:relayId' element={<DetailsPage />} />
        <Route path='tokens' element={<ExternalTokensPage />} />
        <Route path='relayers' element={<RelayersPage />} />
        <Route path='connections' element={<ConnectionsPage />} />
        <Route path='*' element={<HomePage />} />
      </Routes>
      <PageFooter/>
    </>
  )
}

export default Page
